






































































































import { Component, Vue } from "vue-property-decorator";
import feather from "feather-icons";
import { mixins } from "vue-class-component";
import UserValidator from "@/resources/mixins/userValidator";
import SidebarHelpComponent from "@/app/views/nubii/components/sidebar/components/sidebarHelp.component.vue";
import { CHAT_TYPE } from "@/resources/constants/chat";
import moment from "moment";
import CollapseButtonComponent from "@/app/views/nubii/components/sidebar/components/collapseButton.component.vue";
import InvitationFormComponent from "@/app/components/manageSpace/components/users/inviteUsers/invitationForm.component.vue";
import { GREEN, RED, YELLOW } from "@/resources/constants/busyReasons";
import { SpaceUserInterface } from "@/resources/interfaces/spaceUserInterfaces";
import Plans from "@/resources/mixins/plans/plans";
import { PLAN } from "@/resources/constants/plan";
@Component({
  name: "chat-menu-component",
  components: {
    InvitationFormComponent,
    CollapseButtonComponent,
    SidebarHelpComponent,
  },
})
export default class ChatMenuComponent extends mixins(UserValidator, Plans) {
  openChats = [];
  loading = true;
  page = 1;
  lastPage = 2;
  lastScroll = 0;
  PLAN = PLAN;
  mounted() {
    feather.replace();
    this.getOpenChats();
    setTimeout(() => {
      this.openChatContainerHeight();
    }, 50);
    window.addEventListener("resize", this.openChatContainerHeight);
    this.onScrollEvent();
  }
  destroyed() {
    window.removeEventListener("resize", this.openChatContainerHeight);
  }
  checkOwner(): boolean {
    const space = this.$store.getters["SpaceStore/getSpace"];
    const user = this.$store.getters["UserStore/getSpaceUser"];
    return space.superSpace.createdBy.id === user.superSpaceUser.user.id;
  }
  isMultiSpace() {
    const space = this.$store.getters["SpaceStore/getSpace"];
    return space.superSpace.isExpandable;
  }
  get listOpenChats() {
    return this.openChats.sort((a, b) =>
      this.unSeeMessage.filter(
        (unSee) =>
          unSee.type === CHAT_TYPE.ONE_TO_ONE &&
          unSee.id === a.superSpaceUser.id
      ).length > 0
        ? -1
        : 1
    );
  }
  get unSeeMessage() {
    return this.$store.getters["ChatStore/getUnSeenMessage"];
  }

  get showTotalGeneralUnSeeMessage() {
    return this.unSeeMessage.filter((a) => a.type === CHAT_TYPE.SPACE).length;
  }
  get unSeeMessageWithoutOpenChat() {
    return this.unSeeMessage
      .filter(
        (a) =>
          a.type === CHAT_TYPE.ONE_TO_ONE &&
          this.listOpenChats.findIndex((list) => list.spaceUser.id === a.id) < 0
      )
      .filter((item, pos) => {
        return this.unSeeMessage.findIndex((a) => a.id === item.id) == pos;
      });
  }
  setActiveMenu(e) {
    const element = document.getElementsByClassName("open-menu-container")[0];
    if (element) element["style"].left = "-23rem";
    setTimeout(() => {
      this.$store.dispatch("SidebarStore/setActiveMenuAction", e);
    }, 500);
  }
  openChatContainerHeight() {
    const chatMenuContainer = document.getElementById("chat-menu-container");
    const openChatsContainer = document.getElementById("open-chats-container");
    openChatsContainer.style.height =
      chatMenuContainer.clientHeight - 360 + "px";
  }
  openGeneralChat() {
    const space = this.$store.getters["SpaceStore/getSpace"];
    const chatType = this.$store.getters["ChatStore/getChatType"];
    this.$store.dispatch("ChatStore/setMessagesAction", []);
    this.$store.dispatch("ChatStore/setUserChatAction", null);
    this.$store.dispatch("SidebarStore/setOpenChatAction", false);
    setTimeout(() => {
      this.$store.dispatch("ChatStore/setChatTypeAction", CHAT_TYPE.SPACE);
      this.$store.dispatch("ChatStore/removeUnSeenMessageAction", {
        type: CHAT_TYPE.SPACE,
      });
      this.$store.dispatch("SidebarStore/setOpenChatAction", true);
      this.$store.dispatch("ChatStore/setMinimizeChatAction", false);
      const element = document.getElementsByClassName("open-menu-container")[0];
      if (element) element["style"].left = "-23rem";
      setTimeout(() => {
        this.$store.dispatch("SidebarStore/setActiveMenuAction", -1);
      }, 500);
    }, 50);
  }

  getShowUserUnSeenMessages(id) {
    return this.unSeeMessage.filter(
      (a) => a.type === CHAT_TYPE.ONE_TO_ONE && a.id === id
    ).length;
  }
  get isChatActive() {
    return this.$store.getters["SpaceStore/getSpace"].isChatActive;
  }
  get showUsersMessages() {
    const usersMessage = this.unSeeMessage.filter(
      (a) => a.type === CHAT_TYPE.ONE_TO_ONE
    );
    return usersMessage
      .sort((a, b) =>
        moment(a.payload.CreatedTimestamp).isAfter(
          moment(b.payload.CreatedTimestamp)
        )
          ? -1
          : 1
      )
      .filter((item, pos) => {
        return usersMessage.findIndex((a) => a.id === item.id) == pos;
      });
  }
  async openUserChat(user) {
    await this.$store.dispatch("ChatStore/setMessagesAction", []);
    await this.$store.dispatch("ChatStore/setUserChatAction", {
      superSpaceUser: user.superSpaceUser,
      user: user.superSpaceUser.user,
    });
    await this.$store.dispatch("SidebarStore/setOpenChatAction", false);
    await this.$store.dispatch(
      "ChatStore/setChatTypeAction",
      CHAT_TYPE.ONE_TO_ONE
    );
    await this.$store.dispatch("GraphicClientStore/resizeGraphicClientAction");
    await this.$store.dispatch("SidebarStore/setOpenChatAction", true);
    this.$store.dispatch("ChatStore/setMinimizeChatAction", false);
    await this.$store.dispatch("GraphicClientStore/resizeGraphicClientAction");
    await this.$store.dispatch("ChatStore/removeUnSeenMessageAction", {
      id: user.superSpaceUser.id,
      type: CHAT_TYPE.ONE_TO_ONE,
    });
  }
  getOpenChats() {
    const space = this.$store.getters["SpaceStore/getSpace"];
    if (this.page <= this.lastPage) {
      this.$store.dispatch("ChatStore/getOpenChatsAction", {
        spaceId: space.id,
        page: this.page,
        callback: (response) => {
          this.loading = false;
          this.openChats = [...this.openChats, ...response.data];
          this.page += 1;
          this.lastPage = response.headers["pagination-last-page"];
        },
        callbackError: (error) => {
          this.loading = false;
        },
      });
    } else {
      this.loading = false;
    }
  }
  setAvatarColor(color: string): string {
    switch (color) {
      case GREEN.type:
        return GREEN.color;
      case RED.type:
        return RED.color;
      case YELLOW.type:
        return YELLOW.color;
      default:
        return RED.color;
    }
  }
  onScrollEvent() {
    const openChat = document.getElementById("open-chats-container");
    openChat.addEventListener("scroll", () => {
      const a = openChat.scrollTop;
      const b = openChat.scrollHeight - openChat.clientHeight;
      if (this.lastScroll < 0.6 && a / b > 0.6) {
        this.loading = true;
        this.getOpenChats();
        this.lastScroll = a / b;
      }
    });
  }
}
